import { render, staticRenderFns } from "./PageJiFen.vue?vue&type=template&id=77a5c6ed&scoped=true&"
import script from "./PageJiFen.vue?vue&type=script&lang=js&"
export * from "./PageJiFen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5c6ed",
  null
  
)

export default component.exports